import React, { useState, useEffect, Fragment } from "react";
import { Container, ListGroup, ListGroupItem } from "reactstrap";
import BreadCrumb from "../../components/Common/BreadCrumb";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { translateApiError } from "../../helpers/translateApiError";
import getHxsmsTokenStorage from "../../helpers/getHxsmsTokenStorage";

import DeleteTeamModal from "../../components/Common/DeleteTeamModal";
import InviteTeamModal from "../../components/Common/InviteTeamModal";

import useAuthUser from "../../components/Hooks/useAuthUser";
import { getUserRole } from "../Users/api/usersApi";

//redux
import { useSelector, useDispatch } from "react-redux";
import { getTeam, deleteTeam, resetTeamError } from "../../store/actions";

import NoDataFound from "../../components/Common/NoDataFound";

const Team = () => {
  const { t } = useTranslation();
  document.title = t("common.pageTitle", { page: t("team.pageTitle") });
  const dispatch = useDispatch();
  const history = useHistory();
  const { isAdmin, isSuperAdmin, userProfile } = useAuthUser();

  // State for user role
  const [currentUserRole] = useState(() => getUserRole());

  const isTenantAdmin = currentUserRole === "TENANT_ADMIN";

  const { team, status, error, isUserSwitch, isChannelLoading } = useSelector(
    (state) => ({
      team: state.Team.team,
      status: state.Team.status,
      error: state.Team.error,
      isUserSwitch: state.Profile.userSwitch.isUserSwitch,
      userSwitchEmail: state.Profile.userSwitch.email,
      isChannelLoading: state.Channel.isChannelLoading,
    })
  );

  const [teamToDelete, setTeamToDelete] = useState({});

  // Modals
  const [inviteTeamModal, setInviteTeamModal] = useState(false);
  const [deleteTeamModal, setDeleteTeamModal] = useState(false);

  //Invite
  const handleCloseInviteTeamModal = () => {
    dispatch(resetTeamError());
    setInviteTeamModal(false);
  };

  //Delete
  const handleDeleteClick = (teamDetails) => {
    setTeamToDelete(teamDetails);
    setDeleteTeamModal(true);
  };

  const handleCloseDeleteClientModal = () => {
    setTeamToDelete({});
    dispatch(resetTeamError());
    setDeleteTeamModal(false);
  };

  const handleConfirmDeleteClient = () => {
    if (teamToDelete) {
      dispatch(deleteTeam(teamToDelete.id));
    }
  };

  useEffect(() => {
    const hxsmsToken = getHxsmsTokenStorage();
    if (!hxsmsToken || isChannelLoading) return;
    dispatch(getTeam());
  }, [dispatch, isChannelLoading]);

  useEffect(() => {
    if (!isUserSwitch && isSuperAdmin) history.push("/dashboard");
  }, [isUserSwitch, isSuperAdmin, history]);

  return (
    <React.Fragment>
      <InviteTeamModal
        show={inviteTeamModal}
        onDeleteClick={handleConfirmDeleteClient}
        onCloseClick={() => {
          handleCloseInviteTeamModal();
        }}
      />
      <DeleteTeamModal
        show={deleteTeamModal}
        onDeleteClick={handleConfirmDeleteClient}
        onCloseClick={() => {
          handleCloseDeleteClientModal();
        }}
        teamToDelete={teamToDelete}
      />
      {error ? (
        <>
          {toast(`${translateApiError(error)}`, {
            position: "top-right",
            hideProgressBar: false,
            type: "error",
            className: "",
            progress: undefined,
            toastId: "",
          })}
          <ToastContainer autoClose={2000} limit={1} />
        </>
      ) : null}
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={t("team.pageTitle")}
            pageTitle={t("team.breadcrumbSettings")}
          />
          <div className="teams">
            <div className="teams__invite bg-white rounded-1 py-4 d-flex justify-content-end border-1 border-gray-100">
              {isTenantAdmin && (
                <button
                  onClick={() => {
                    setInviteTeamModal(true);
                  }}
                  className="text__invite-button btn btn-warning text-primary rounded-3 d-flex align-items-center gap-1"
                >
                  <i className="ri-user-add-fill"></i>
                  {t("team.invite")}
                </button>
              )}
            </div>
            <div className="teams__heading__container">
              <h6 className="teams__heading my-3">
                {t("common.labels.email")}
              </h6>
              {isTenantAdmin && (
                <h6 className="teams__heading my-3">
                  {t("common.actions.delete")}
                </h6>
              )}
            </div>

            <ListGroup className="teams__list border-1 border-gray-100">
              {team?.map((teamDetails) => (
                <ListGroupItem
                  className="teams__list-item border-1 border-gray-100 py-3 text-primary"
                  key={teamDetails.id}
                >
                  {teamDetails.emailAddress}
                  {isTenantAdmin &&
                    teamDetails.emailAddress !== userProfile?.email && (
                      <i
                        onClick={() => {
                          handleDeleteClick(teamDetails);
                        }}
                        className="teams__list-delete ri-delete-bin-5-fill"
                        style={{ color: "#E94A53" }}
                      ></i>
                    )}
                </ListGroupItem>
              ))}
            </ListGroup>

            {status === "loading" && team?.length !== 0 && (
              <ListGroup className="teams__list border-1 border-gray-100">
                {[...Array(8).keys()].map((row) => {
                  return (
                    <ListGroupItem
                      className="teams__list-item border-1 border-gray-100 py-3 text-primary"
                      key={row}
                    >
                      <Skeleton count={0.8} width={100} />
                      {isTenantAdmin && <Skeleton count={0.8} width={100} />}
                    </ListGroupItem>
                  );
                })}
              </ListGroup>
            )}

            {status === "idle" && team?.length === 0 && <NoDataFound />}
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Team;
